import { createSlice } from "@reduxjs/toolkit";

const initialAdminDashboardState = {
  listLoading: false,
  unknownEmailSenderlistLoading: false,
  actionsLoading: false,
  totalCount: 0,
  totalCountUnknownEmailSender: 0,
  unMappedFiles: null,
  unknownEmailSenders: null,
  lastError: null,
  newAccounts: null,
  totalAccounts: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const adminDashboardSlice = createSlice({
  name: "adminDashboard",
  initialState: initialAdminDashboardState,
  reducers: {
    catchError: (state, action) => {
      //     state.error = `${action.type}: ${action.payload.error}`;
      state.error = action.payload.error.response.data.error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        //  state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    setUnMappedFilesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.unMappedFiles = entities;
      state.totalCount = totalCount;
      state.error = null;
    },
    SetUnknownEmailSendersFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.unknownEmailSenderlistLoading = false;
      state.error = null;
      state.unknownEmailSenders = entities;
      state.totalCountUnknownEmailSender = totalCount;
    },
    setAccountsStatistics: (state, action) => {
      state.listLoading = false;
      state.totalAccounts = action.payload.totalAccounts;
      state.newAccounts = action.payload.newAccounts;
    },
  },
});
